var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity-404"},[_vm._m(0),_c('div',{staticClass:"activity-404-label",domProps:{"innerHTML":_vm._s('页面可能出国旅游了~(>_<)~')}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity-404-img"},[_c('img',{attrs:{"src":require("../../assets/imgs/activity_404.png")}})])
}]

export { render, staticRenderFns }